import styled from "styled-components";
import { device } from "../helpers/deviceConfig";

export const SmallText = styled.p`
  @media ${device.desktopL} {
    font-size: 30px;
  }
`;
